import PropTypes from "prop-types";
import React from "react";
import "./style.css";
import { Link } from 'react-router-dom';


export const Header = ({
  className
}) => {
  return (
    <div className={`header ${className}`}>
      <div className="header-buttons-os">
        <Link to="/bookchoice" className="button">Bücher</Link>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLScjIo_QdN3UIe8y8SQbPgFBpWULn5g_-DpCJsEvq0myWsKZag/viewform" target="_blank" rel="noopener noreferrer" className="button-long">Feedback</a>
        <a href="https://werobots-cottbus.github.io/index.html" target="_blank" rel="noopener noreferrer" className="button-long">WeRobots</a>
      </div>
      <Link to = '/landingpage' ><img src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/background%2FLogo%20Orange-Transparent.png?alt=media&token=ab35a24f-80af-4415-9575-15ab579ad058" alt="Logo" className="header-image" /></Link>
      <Link to ='/' className="text-wrapper">WeRead</Link>
      <Link to = "/" className="small-under-text-warpper">hier klicken für Beschreibung & Impressum</Link>
    </div>
  );
};

Header.propTypes = {
  menuIconDefaultVector: PropTypes.string,
  menuIconDefaultImg: PropTypes.string,
  menuIconDefaultVector1: PropTypes.string,
  menuIconDefaultVector2: PropTypes.string,
};